module.exports = __webpack_public_path__ + "img/tab-logo.38e6bf56.svg";